// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.setupBg {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--AccentColor);
}
.setupBg .Slider {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.setupBg .Slider .setupComp {
  width: 45%;
  position: absolute;
  background-color: var(--Foreground);
  border-radius: 1.25rem;
  z-index: 2;
  transition: all 0.7s ease-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  gap: 1.25rem;
}
.setupBg .Slider .setupComp .dummyContainer {
  width: 90%;
  top: 8%;
  z-index: -1;
  height: 100%;
  position: absolute;
  opacity: 0.3;
  /* transform: translate(0, 12%) scale(0.9); */
  background-color: var(--Foreground);
  border-radius: 1.25rem;
}
.setupBg .Slider .setupComp h1 {
  text-align: center;
  font-size: 2rem;
  font-weight: 600;
  color: var(--TextColor);
}
.setupBg .Slider .setupComp p {
  text-align: center;
  font-size: 0.9rem;
  line-height: 1.25rem;
  color: var(--TextColor);
}
.setupBg .Slider .setupComp p span {
  font-weight: 700;
  color: var(--AccentColor);
}
.setupBg .Slider .setupComp button {
  background-color: var(--AccentColor);
  color: white;
  padding: 1rem 2.5rem;
  border-radius: 0.3rem;
  font-size: 1rem;
  font-weight: 600;
}

@media (max-width: 900px) {
  .setupBg .Slider .setupComp {
    width: 50%;
  }
}
@media (max-width: 700px) {
  .setupBg .Slider .setupComp {
    width: 65%;
  }
}
@media (max-width: 550px) {
  .setupBg {
    flex-direction: column;
    gap: 1.25rem;
  }
  .setupBg .leftBarComp {
    background-color: transparent;
    width: 100%;
    height: auto;
    padding-top: 2rem;
  }
  .setupBg .leftBarComp svg {
    display: none;
  }
  .setupBg .leftBarComp .cmpRegContent {
    display: none;
  }
  .setupBg .leftBarComp h1 {
    color: white;
  }
  .setupBg .leftBarComp .formCompletion {
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: center;
  }
  .setupBg .leftBarComp .formCompletion div {
    flex-direction: column;
  }
  .setupBg .leftBarComp .formCompletion div p {
    text-align: center;
  }
  .setupBg .leftBarComp .formCompletion div .completed {
    color: white;
  }
  .setupBg .leftBarComp .formCompletion div .completedImg {
    border: 1px solid white;
    border-radius: 50%;
  }
  .setupBg .leftBarComp .formCompletion div img {
    width: 2.5rem;
    height: 2.5rem;
  }
  .setupBg .animationComp {
    flex: 1 1;
    width: 100%;
  }
  .setupBg .animationComp .next {
    display: none;
  }
  .setupBg .animationComp .inputContainers {
    gap: 2.5rem;
  }
  .setupBg .animationComp .companyInfoBg {
    width: 80%;
    min-height: 70%;
    justify-content: space-evenly;
  }
  .setupBg .animationComp .overviewBg {
    width: 80%;
    min-height: 70%;
    justify-content: space-evenly;
  }
  .setupBg .animationComp .detailsBg {
    width: 80%;
    max-height: 85%;
    padding: 1.25rem 0rem;
  }
  .setupBg .Slider .setupComp {
    width: 75%;
  }
}
@media (max-width: 380px) {
  .setupBg .Slider .setupComp {
    width: 90%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/CompanyRegistration/Setup/Setup.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EAEA,mBAAA;EACA,uBAAA;EACA,oCAAA;AAAJ;AACI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACR;AAAQ;EAYI,UAAA;EAEA,kBAAA;EACA,mCAAA;EACA,sBAAA;EACA,UAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;AAVZ;AAbY;EACI,UAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,6CAAA;EACA,mCAAA;EACA,sBAAA;AAehB;AAAY;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;AAEhB;AAAY;EACI,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,uBAAA;AAEhB;AADgB;EACI,gBAAA;EACA,yBAAA;AAGpB;AAAY;EACI,oCAAA;EACA,YAAA;EACA,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AAEhB;;AAMA;EAGY;IACI,UAAA;EALd;AACF;AASA;EAGY;IACI,UAAA;EATd;AACF;AAaA;EACI;IACI,sBAAA;IACA,YAAA;EAXN;EAYM;IACI,6BAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;EAVV;EAWU;IACI,aAAA;EATd;EAWU;IACI,aAAA;EATd;EAWU;IACI,YAAA;EATd;EAWU;IACI,mBAAA;IACA,WAAA;IACA,mBAAA;IACA,uBAAA;EATd;EAUc;IACI,sBAAA;EARlB;EASkB;IACI,kBAAA;EAPtB;EASkB;IACI,YAAA;EAPtB;EASkB;IACI,uBAAA;IACA,kBAAA;EAPtB;EASkB;IACI,aAAA;IACA,cAAA;EAPtB;EAYM;IACI,SAAA;IACA,WAAA;EAVV;EAWU;IACI,aAAA;EATd;EAWU;IACI,WAAA;EATd;EAWU;IACI,UAAA;IACA,eAAA;IACA,6BAAA;EATd;EAWU;IACI,UAAA;IACA,eAAA;IACA,6BAAA;EATd;EAWU;IACI,UAAA;IACA,eAAA;IACA,qBAAA;EATd;EAaU;IACI,UAAA;EAXd;AACF;AAeA;EAGY;IACI,UAAA;EAfd;AACF","sourcesContent":[".setupBg{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    // flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--AccentColor);\n    .Slider{\n        position: relative;\n        width: 100%;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        .setupComp{\n            .dummyContainer{\n                width: 90%;\n                top: 8%;\n                z-index: -1;\n                height: 100%;\n                position: absolute;\n                opacity: 0.3;\n                /* transform: translate(0, 12%) scale(0.9); */\n                background-color: var(--Foreground);\n                border-radius: 1.25rem;\n            }\n            width: 45%;\n            // height: 50%;\n            position: absolute;\n            background-color: var(--Foreground);\n            border-radius: 1.25rem;\n            z-index: 2;\n            transition: all 0.7s ease-out;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            padding: 1.25rem;\n            gap: 1.25rem;\n            h1{\n                text-align: center;\n                font-size: 2rem;\n                font-weight: 600;\n                color: var(--TextColor);\n            }\n            p{\n                text-align: center;\n                font-size: .9rem;\n                line-height: 1.25rem;\n                color: var(--TextColor);\n                span{\n                    font-weight: 700;\n                    color: var(--AccentColor);\n                }\n            }\n            button{\n                background-color: var(--AccentColor);\n                color: white;\n                padding: 1rem 2.5rem;\n                border-radius: .3rem;\n                font-size: 1rem;\n                font-weight: 600;\n            }\n        }\n        \n    }\n    \n}\n\n@media (max-width: 900px) {\n    .setupBg{\n        .Slider{\n            .setupComp{\n                width: 50%;\n            }\n        }\n    }\n}\n@media (max-width: 700px) {\n    .setupBg{\n        .Slider{\n            .setupComp{\n                width: 65%;\n            }\n        }\n    }\n}\n@media (max-width: 550px) {\n    .setupBg{\n        flex-direction: column;\n        gap: 1.25rem;\n        .leftBarComp{\n            background-color: transparent;\n            width: 100%;\n            height: auto;\n            padding-top: 2rem;\n            svg{\n                display: none;\n            }\n            .cmpRegContent{\n                display: none;\n            }\n            h1{\n                color: white;\n            }\n            .formCompletion{\n                flex-direction: row;\n                width: 100%;\n                align-items: center;\n                justify-content: center;\n                div{\n                    flex-direction: column;\n                    p{\n                        text-align: center;\n                    }\n                    .completed {\n                        color: white;\n                    }\n                    .completedImg{\n                        border: 1px solid white;\n                        border-radius: 50%;\n                    }\n                    img{\n                        width: 2.5rem;\n                        height: 2.5rem;\n                    }\n                }\n            }\n        }\n        .animationComp{\n            flex: 1;\n            width: 100%;\n            .next{\n                display: none;\n            }\n            .inputContainers{\n                gap: 2.5rem;\n            }\n            .companyInfoBg{\n                width: 80%;\n                min-height: 70%;\n                justify-content: space-evenly;\n            }\n            .overviewBg {\n                width: 80%;\n                min-height: 70%;\n                justify-content: space-evenly;\n            }\n            .detailsBg{\n                width: 80%;\n                max-height: 85%;\n                padding: 1.25rem 0rem;\n            }\n        }\n        .Slider{\n            .setupComp{\n                width: 75%;\n            }\n        }\n    }\n}\n@media (max-width: 380px) {\n    .setupBg{\n        .Slider{\n            .setupComp{\n                width: 90%;\n            }\n        }\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
